import { PaginationProps, PaginationReturn } from '@common/types/service';
import {
    FeedbackData,
    FeedbackResponse,
    IInstallation,
    IInstallationForValidation,
    ISavedInstallation,
    IValidationResult,
} from '@extendedWarranty/types/extendedWarranty';
import { getFilterString, getPaginationString } from '@utils/service';
import { api } from '../../../services/api';

const extendedWarrantyApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getInstallations: builder.query<PaginationReturn<IInstallation>, PaginationProps>({
            query: ({ filters, ...pagination }) =>
                `extended-warranty/request?${getPaginationString(pagination)}${
                    filters ? getFilterString(filters) : ''
                }`,
            providesTags: ['Installations'],
        }),
        validateSerialNumbers: builder.mutation<IValidationResult, IInstallationForValidation>({
            query: (installationData) => ({
                url: 'extended-warranty/validate/',
                body: installationData,
                method: 'POST',
            }),
        }),
        saveSerialNumbers: builder.mutation<ISavedInstallation, IInstallationForValidation>({
            query: (installationData) => ({
                url: 'extended-warranty/save/',
                body: installationData,
                method: 'POST',
            }),
            invalidatesTags: ['Installations'],
        }),
        sendFeedback: builder.mutation<FeedbackResponse, FeedbackData>({
            query: (body) => ({ url: 'extended-warranty/feedback', body, method: 'POST' }),
        }),
    }),
});

export const {
    useGetInstallationsQuery,
    useSaveSerialNumbersMutation,
    useValidateSerialNumbersMutation,
    useSendFeedbackMutation,
} = extendedWarrantyApi;
